import { useEffect, useState } from "react";
import {
  DeleteAdminMutation,
  useDeleteAdminMutation,
} from "@/generated/graphql_billing";
import { ApolloError } from "@apollo/client";
import useRollbarUtil from "./useRollbarUtil";

type MutationResult = {
  loading: boolean;
  error?: ApolloError;
  data?: DeleteAdminMutation;
};

export const useCallBillingDeleteAdminMutation = (): [
  (userSub: string) => Promise<MutationResult>
] => {
  const { rollbar } = useRollbarUtil();
  const [deleteAdminMutation] = useDeleteAdminMutation({
    context: {
      api: "billing",
    },
  });

  const executeMutation = async (userSub: string): Promise<MutationResult> => {
    try {
      const { data, errors } = await deleteAdminMutation({
        variables: { input: { userSub } },
      });

      if (errors && errors.length > 0) {
        throw new Error(errors.map((e) => e.message).join("\n"));
      }

      return { loading: false, error: undefined, data };
    } catch (err) {
      rollbar.error("Failed to delete admin", err);
      return { loading: false, error: err, data: undefined };
    }
  };

  return [executeMutation];
};
